{
  "background": {
    "primary": "#161d45",
    "secondary": "#0d143a",
    "brand": {
      "primary": "#454f88",
      "secondary": "#2b335e"
    },
    "brandExtra": {
      "primary": "#292f52",
      "secondary": "#2d3358"
    },
    "inverse": "#000000",
    "static": {
      "dark": "#000000",
      "light": "#ffffff"
    },
    "success": {
      "primary": "#14b87e",
      "secondary": "#75f0b9"
    },
    "warning": {
      "primary": "#ffee99",
      "secondary": "#ffdd33"
    },
    "alert": {
      "primary": "#e80000",
      "secondary": "#f53d3d"
    },
    "neutral": {
      "primary": "#7f8bc9",
      "secondary": "#2b335e"
    }
  },
  "content": {
    "primary": "#ffffff",
    "secondary": "rgba(255, 255, 255, 0.76)",
    "tertiary": "rgba(255, 255, 255, 0.58)",
    "brand": {
      "primary": "#ffffff",
      "secondary": "rgba(255, 255, 255, 0.76)"
    },
    "brandExtra": {
      "primary": "#8576fd",
      "secondary": "#aea0ff"
    },
    "inverse": "#000000",
    "static": {
      "light": "#ffffff",
      "dark": "#000000"
    },
    "success": {
      "primary": "#66ffa6",
      "secondary": "#00ff6a"
    },
    "warning": {
      "primary": "#ffe566",
      "secondary": "#ffd400"
    },
    "alert": {
      "primary": "#e80000",
      "secondary": "#f53d3d"
    },
    "neutral": {
      "primary": "#aa99ff",
      "secondary": "#8066ff"
    },
    "on": {
      "brand": "#ffffff",
      "brandExtra": "#0d143a",
      "success": "#000000",
      "warning": "#000000",
      "alert": "#ffffff",
      "neutral": "#0d143a"
    }
  },
  "border": {
    "primary": "#ffffff",
    "secondary": "rgba(255, 255, 255, 0.12)",
    "brand": "#ffffff",
    "brandExtra": "#8576fd",
    "inverse": "rgba(0, 0, 0, 0.15)",
    "success": "#75f0b9",
    "warning": "#ffe566",
    "alert": "#f53d3d",
    "neutral": "#7f8bc9"
  },
  "overlay": {
    "mono": "rgba(255, 255, 255, 0.1)",
    "brand": "rgba(83, 94, 153, 0.5)",
    "brandExtra": "rgba(133, 118, 253, 0.3)",
    "success": "rgba(20, 184, 126, 0.3)",
    "warning": "rgba(255, 229, 102, 0.3)",
    "alert": "rgba(245, 61, 61, 0.3)",
    "neutral": "rgba(127, 139, 201, 0.3)",
    "monoHover": "rgba(255, 255, 255, 0.2)"
  },
  "layer": {
    "scrim": "rgba(0, 0, 0, 0.5)",
    "float": "rgba(10, 15, 43, 0.75)"
  },
  "control": {
    "brand": {
      "primary": {
        "bg": "#ffca43",
        "bgHover": "#f2c173",
        "bgPress": "#ffbb33",
        "bgDisable": "#484848",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)",
        "borderDisable": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "#ffffff",
        "bgHover": "#e3e3e3",
        "bgPress": "#bbbbbb",
        "border": "rgba(255, 255, 255, 0.2)",
        "borderHover": "rgba(255, 255, 255, 0.4)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(255, 255, 255, 0.1)",
        "bgHover": "rgba(255, 255, 255, 0.76)",
        "bgPress": "rgba(255, 255, 255, 0.5)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#000000",
        "tertiary": "#000000",
        "disable": "#c4d1d4",
        "ghost": "#ffca43"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 202, 67, 0.04)",
        "bgPress": "rgba(255, 202, 67, 0.08)",
        "border": "rgba(255, 202, 67, 0.16)",
        "borderHover": "rgba(255, 202, 67, 0.24)",
        "borderPress": "rgba(255, 202, 67, 0.16)"
      }
    },
    "mono": {
      "primary": {
        "bg": "#ffffff",
        "bgHover": "#f0f4f4",
        "bgPress": "#f6f8f9",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "rgba(255, 255, 255, 0.1)",
        "bgHover": "rgba(255, 255, 255, 0.34)",
        "bgPress": "rgba(255, 255, 255, 0.44)",
        "border": "#ffffff",
        "borderHover": "#ffffff",
        "borderPress": "#ffffff"
      },
      "tertiary": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 255, 255, 0.76)",
        "bgPress": "rgba(255, 255, 255, 0.5)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#0d143a",
        "secondary": "#ffffff",
        "tertiary": "#ffffff",
        "ghost": "#ffffff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 255, 255, 0.04)",
        "bgPress": "rgba(255, 255, 255, 0.08)",
        "border": "rgba(255, 255, 255, 0.16)",
        "borderHover": "rgba(255, 255, 255, 0.24)",
        "borderPress": "rgba(255, 255, 255, 0.16)"
      }
    },
    "brandExtra": {
      "primary": {
        "bg": "#8576fd",
        "bgHover": "#9d95de",
        "bgPress": "#6b5fd4",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "rgba(133, 118, 253, 0.4)",
        "bgHover": "rgba(157, 149, 222, 0.4)",
        "bgPress": "rgba(107, 95, 212, 0.4)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(133, 118, 253, 0.1)",
        "bgHover": "rgba(133, 118, 253, 0.2)",
        "bgPress": "rgba(133, 118, 253, 0.3)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#000000",
        "tertiary": "#8576fd",
        "ghost": "#ffffff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 255, 255, 0.04)",
        "bgPress": "rgba(255, 255, 255, 0.08)",
        "border": "rgba(255, 255, 255, 0.16)",
        "borderHover": "rgba(255, 255, 255, 0.24)",
        "borderPress": "rgba(255, 255, 255, 0.16)"
      }
    },
    "alert": {
      "bg": "#e80000",
      "border": "#f53d3d",
      "primary": {
        "bg": "#ff8066",
        "bgHover": "#ffaa99",
        "bgPress": "#ff5533",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "secondary": {
        "bg": "rgba(255, 128, 102, 0.4)",
        "bgHover": "rgba(255, 170, 153, 0.4)",
        "bgPress": "rgba(255, 85, 51, 0.4)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(232, 79, 48, 0)",
        "bgHover": "rgba(246, 112, 85, 0.07)",
        "bgPress": "rgba(246, 112, 85, 0.12)",
        "border": "rgba(255, 255, 255, 0)",
        "borderHover": "rgba(255, 255, 255, 0)",
        "borderPress": "rgba(255, 255, 255, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#000000",
        "tertiary": "#ff8066",
        "ghost": "#ffffff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 255, 255, 0.04)",
        "bgPress": "rgba(255, 255, 255, 0.08)",
        "border": "rgba(255, 255, 255, 0.16)",
        "borderHover": "rgba(255, 255, 255, 0.24)",
        "borderPress": "rgba(255, 255, 255, 0.16)"
      }
    },
    "input": {
      "bg": "#292f52",
      "bgHover": "#2d3661",
      "bgDisable": "rgba(255, 255, 255, 0.25)",
      "border": "#7f8bc9",
      "borderHover": "rgba(127, 139, 201, 0.7)",
      "borderDisable": "rgba(255, 255, 255, 0)",
      "text": "#ffffff",
      "placeholder": "rgba(255, 255, 255, 0.55)",
      "textDisable": "rgba(255, 255, 255, 0.36)"
    },
    "focus": {
      "bg": "#0a0f2b",
      "border": "#8576fd"
    },
    "check": {
      "bg": "#ffffff",
      "bgHover": "#f6f8f9",
      "bgDisable": "rgba(255, 255, 255, 0.2)",
      "border": "#ffffff",
      "borderHover": "#ffffff",
      "borderDisable": "rgba(255, 255, 255, 0.2)",
      "icon": "#0d143a"
    },
    "faint": {
      "bg": "rgba(255, 202, 67, 0.15)",
      "bgHover": "rgba(255, 202, 67, 0.2)",
      "border": "rgba(255, 202, 67, 0.1)",
      "borderHover": "rgba(255, 202, 67, 0.24)"
    },
    "slider": {
      "bg": "#ffffff",
      "bgHover": "#ffffff",
      "bgDisable": "rgba(255, 255, 255, 0.2)"
    },
    "switch": {
      "bg": "#d4a832",
      "bgHover": "#c49a2d",
      "bgDisable": "rgba(0, 0, 0, 0.25)",
      "border": "#ffca43",
      "borderHover": "#ffca43",
      "borderDisable": "rgba(0, 0, 0, 0)"
    },
    "knob": {
      "bg": "#ffca43",
      "bgHover": "#f0bc35",
      "bgActive": "#ffffff",
      "bgActiveHover": "#f6f8f9",
      "bgInactive": "#ffffff",
      "bgInactiveHover": "#f6f8f9",
      "bgDisable": "#454f88"
    },
    "text": {
      "primary": "#ffffff",
      "disable": "#8c8b9a"
    },
    "link": {
      "primary": "#ffffff",
      "primaryHover": "rgba(255, 255, 255, 0.7)",
      "secondary": "#8576fd",
      "secondaryHover": "rgba(157, 149, 222, 0.7)"
    },
    "segmented": {
      "bg": "rgba(255, 255, 255, 0.1)",
      "bgHover": "rgba(255, 255, 255, 0.1)",
      "bgActive": "rgba(255, 255, 255, 0.15)",
      "border": "rgba(255, 255, 255, 0.1)",
      "borderHover": "rgba(255, 255, 255, 0.1)",
      "borderActive": "rgba(255, 255, 255, 0)",
      "text": "#ffffff",
      "textDisable": "rgba(255, 255, 255, 0.4)"
    },
    "tagLabel": {
      "product": {
        "bg": "#d9ff66",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "rarity": {
        "bg": "#141d1f",
        "text": "#22a8c3"
      },
      "name": {
        "bg": "#ffffff",
        "text": "#b7c5c8"
      },
      "account": {
        "bg": "#9580ff",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "id": {
        "bg": "#d7dee0",
        "bgSeries": "#000000",
        "textSeries": "#b7c5c8",
        "textNumber": "#b7c5c8",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "subentity": {
        "bg": "#607f85",
        "text": "#000000"
      },
      "item": {
        "bg": "#80eaff",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      }
    },
    "toast": {
      "bg": "#233134"
    },
    "toggleButton": {
      "bg": "rgba(255, 255, 255, 0.1)",
      "bgHover": "rgba(255, 255, 255, 0.15)",
      "bgActive": "#454f88",
      "bgDisable": "rgba(255, 255, 255, 0.25)",
      "border": "rgba(255, 255, 255, 0.1)",
      "borderHover": "rgba(255, 255, 255, 0.15)",
      "borderActive": "#535e99",
      "borderDisable": "rgba(255, 255, 255, 0)",
      "text": "#ffffff",
      "textActive": "#d0d8ff",
      "textDisable": "rgba(255, 255, 255, 0.36)"
    },
    "appButton": {
      "bg": "#ffffff",
      "bgHover": "rgba(255, 255, 255, 0.76)",
      "bgPress": "rgba(255, 255, 255, 0.5)",
      "border": "rgba(255, 255, 255, 0)",
      "borderHover": "rgba(255, 255, 255, 0)",
      "borderPress": "rgba(255, 255, 255, 0)",
      "text": "#000000",
      "textDisable": "#666666"
    }
  }
}
